import React from 'react';

import { Box } from 'styles/box';

import { Item, Wrapper } from './styles';

export interface Props {
  tabs: any;
  selectedTab: string;
  onSelect: (val: string) => void;
  rounded?: boolean;
  small?: boolean;
}

const HorizontalTabs = ({ tabs, selectedTab, onSelect, rounded, small }: Props) => {
  return (
    <Wrapper rounded={rounded} small={small}>
      <Box display="flex">
        {Object.keys(tabs).map((key) => (
          <Item
            key={key}
            isSelected={key === selectedTab}
            onClick={() => onSelect(key)}
            small={small}>
            {tabs[key]}
          </Item>
        ))}
      </Box>
    </Wrapper>
  );
};

export default HorizontalTabs;
